/**
 * Clone a named template from #app-templates and substitute params.
 *
 * For each element with data-param="key":
 *   - if it also has data-param-attr="attrName", sets that attribute to params[key]
 *   - otherwise sets element.textContent to params[key]
 *
 * @param {string} templateId - id of the element inside #app-templates
 * @param {Object} params - substitution key/value pairs
 * @returns {Element} cloned, parameterized element
 */

export function renderTemplate(templateId, params = {}) {
	const appTemplates = document.getElementById("app-templates");
	const tmplNode = appTemplates.content.getElementById(templateId);
	if (!tmplNode) throw new Error(`Template not found: ${templateId}`);

	const clone = tmplNode.cloneNode(true);

	for (const [key, value] of Object.entries(params)) {
		clone.querySelectorAll(`[data-param="${key}"]`).forEach((el) => {
			if (el.dataset.paramAttr) {
				el.setAttribute(el.dataset.paramAttr, value);
			} else {
				el.textContent = value;
			}
		});
	}

	return clone;
}

export function renderNavButtons(backId, nextId, nextLabel = "Next") {
	return renderTemplate("tmpl-nav-buttons", {
		"back-id": backId,
		"next-id": nextId,
		"next-label": nextLabel,
	});
}

export function renderNextButton(nextId, nextLabel = "Next") {
	return renderTemplate("tmpl-nav-next-only", {
		"next-id": nextId,
		"next-label": nextLabel,
	});
}

export function renderQuestionOkLow(name, label, page) {
	const el = renderTemplate("tmpl-question-ok-low", {
		"question-id": name,
		label: label,
		"error-id": `${name}-error`,
	});

	const group = el.querySelector("ion-radio-group");
	group.id = `${name}-group`;
	group.setAttribute("name", name);
	group.setAttribute("data-page", page);

	el.querySelectorAll("ion-radio").forEach((radio) => {
		radio.setAttribute("name", name);
		radio.setAttribute("data-page", page);
	});

	return el;
}

export function renderQuestionOkNotOkDate(name, label, dateLabel, page) {
	const el = renderTemplate("tmpl-question-ok-notok-date", {
		"question-id": name,
		label: label,
		"date-label": dateLabel,
		"error-id": `${name}-error`,
		"detail-id": `${name}-div`,
		"date-error-id": `${name}-date-error`,
	});

	const group = el.querySelector("ion-radio-group");
	group.id = `${name}-group`;
	group.setAttribute("name", name);
	group.setAttribute("data-page", page);

	const [radioOk, radioNotOk] = el.querySelectorAll("ion-radio");
	[radioOk, radioNotOk].forEach((radio) => {
		radio.setAttribute("name", name);
		radio.setAttribute("data-page", page);
	});
	radioOk.id = `${name}-radio-ok`;
	radioNotOk.id = `${name}-radio-notok`;

	const datetimeButton = el.querySelector("ion-datetime-button");
	datetimeButton.id = `${name}-date-button`;
	datetimeButton.setAttribute("datetime", `${name}-date`);

	const datetime = el.querySelector("ion-datetime");
	datetime.id = `${name}-date`;
	datetime.setAttribute("name", `${name}-date`);

	return el;
}

export function renderQuestionOkIssueNa(name, label, page) {
	const el = renderTemplate("tmpl-question-ok-issue-na", {
		"question-id": name,
		label: label,
		"error-id": `${name}-error`,
		"detail-id": `${name}-div`,
		"div-error-id": `${name}-div-error`,
	});

	const group = el.querySelector("ion-radio-group");
	group.id = `${name}-group`;
	group.setAttribute("name", name);
	group.setAttribute("data-page", page);

	el.querySelectorAll("ion-radio").forEach((radio) => {
		radio.setAttribute("name", name);
		radio.setAttribute("data-page", page);
	});

	const textArea = el.querySelector("ion-textarea");
	textArea.id = `${name}-text`;
	textArea.setAttribute("name", `${name}-text`);

	return el;
}

export function renderQuestionOkNotOkNa(name, label, page) {
	const el = renderTemplate("tmpl-question-ok-notok-na", {
		"question-id": name,
		label: label,
		"error-id": `${name}-error`,
	});

	const group = el.querySelector("ion-radio-group");
	group.id = `${name}-group`;
	group.setAttribute("name", name);
	group.setAttribute("data-page", page);

	el.querySelectorAll("ion-radio").forEach((radio) => {
		radio.setAttribute("name", name);
		radio.setAttribute("data-page", page);
	});

	return el;
}

export function renderQuestionOkNotOk(name, label, page) {
	const el = renderTemplate("tmpl-question-ok-notok", {
		"question-id": name,
		label: label,
		"error-id": `${name}-error`,
	});

	const group = el.querySelector("ion-radio-group");
	group.id = `${name}-group`;
	group.setAttribute("name", name);
	group.setAttribute("data-page", page);

	el.querySelectorAll("ion-radio").forEach((radio) => {
		radio.setAttribute("name", name);
		radio.setAttribute("data-page", page);
	});

	return el;
}

export function renderQuestionOkIssue(name, label, page) {
	const el = renderTemplate("tmpl-question-ok-issue", {
		"question-id": name,
		label: label,
		"error-id": `${name}-error`,
		"detail-id": `${name}-div`,
		"div-error-id": `${name}-div-error`,
	});

	const group = el.querySelector("ion-radio-group");
	group.id = `${name}-group`;
	group.setAttribute("name", name);
	group.setAttribute("data-page", page);

	el.querySelectorAll("ion-radio").forEach((radio) => {
		radio.setAttribute("name", name);
		radio.setAttribute("data-page", page);
	});

	const textArea = el.querySelector("ion-textarea");
	textArea.id = `${name}-text`;
	textArea.setAttribute("name", `${name}-text`);

	return el;
}
